// extracted by mini-css-extract-plugin
export default {"logo":"Login_logo__WbGbn","signInTitle":"Login_signInTitle__39GPn"};